module.exports = __webpack_public_path__ + "static/media/banner.5f9f9acc.png";